import { createAction, props } from "@ngrx/store";
import { Project } from "src/app/models/project";

export const ADD_PROJECT = '[project] add project'

export const addProject = createAction(ADD_PROJECT, props<{project : Project[]}>());